import { API } from 'service/API'

import { INetworkServiceInterface } from '../NetworkService'
import { IOrganizationJSON, IOrganizationResJSON } from './OrganizationsModel'

export class OrganizationsService implements INetworkServiceInterface {
  API: API

  constructor(api: API) {
    this.API = api
  }

  getAll = (): Promise<IOrganizationResJSON> => {
    return this.API.network.organization.getAllOrganizations()
  }

  get = (_id: string): Promise<IOrganizationJSON> => {
    return this.API.network.organization.getOrganization(_id)
  }

  findByIds = (_ids: string[]): Promise<IOrganizationJSON[]> => {
    return this.API.network.organization.getManyOrganization(_ids.join(','))
  }

  search = (searchText: string): Promise<IOrganizationResJSON> => {
    return this.API.network.organization.searchOrganization(searchText)
  }

  add = (name: string): Promise<void> => {
    return this.API.network.organization.addOrganization(name)
  }

  save = (organization: Partial<IOrganizationJSON>): Promise<IOrganizationJSON> => {
    return this.API.network.organization.saveOrganization(organization)
  }

  delete = (organizationId: string) => {
    return this.API.network.organization.deleteOrganization(organizationId)
  }
}
